/**
 * Create option list for specialties
 * @param {*} actualTarget 
 * @param {*} targetGroups 
 */
export function generateSpecialtyList(actualTarget, targetGroups) {

    var targetgroups = [];

    targetgroups.push({ key: 1, text: translateTargetgroup(actualTarget.specialty1, targetGroups), value: actualTarget.specialty1 });
    if (actualTarget.specialty2 !== "") targetgroups.push({ key: 2, text: translateTargetgroup(actualTarget.specialty2, targetGroups), value: actualTarget.specialty2 });
    if (actualTarget.specialty3 !== "") targetgroups.push({ key: 3, text: translateTargetgroup(actualTarget.specialty3, targetGroups), value: actualTarget.specialty3 });

    return targetgroups;
} 

/**
 * Get setting by key
 * @param {*} settings 
 */
export function getSetting(settings, key)
{
    if (settings.length === 0) 
    {
        return undefined;
    } 
    else 
    {
        var item = settings.filter( x => x.key === key);
        return item[0].value;
    }
}

/**
 * True if...
 * - april 15 - 30
 * - august 15 - 31
 * - dec 15 - 31
 */
export function isPanelChangePeriod() {

    return false; // INFO always closed, manual panel opening needed

    /*var d = new Date();
    var day = d.getDate();
    var month = d.getMonth() + 1;

    return (day >= 6 && day <= 30 && month === 4) ||
           (day >= 1 && day <= 31 && month === 8) ||
           (day >= 1 && day <= 15 && month === 12);*/
}

/**
 * Translates target group to HU
 * @param {*} specialty 
 */
export function translateTargetgroup(specialty, targetgroups) {
    if (targetgroups.length > 0 && specialty !== undefined)
    {
        var tg = targetgroups.filter(x => x.myPreferredSpecialty === specialty);
        if (tg.length === 0)
        {
            return 'Ismeretlen HU: ' + specialty;
        } 
        else
        {
            return tg[0].myPreferredSpecialtyHu;
        }
    }
    else
    {
        return '...'
    }
}

/**
 * Remove accents from Hungarian string for comparison
 * @param {*} str 
 */
export function removeAccents(str) {
    if (!str) return '';
    return str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''); // Remove diacritical marks
}

/**
 * Validate city and postal code match
 * @param {*} city 
 * @param {*} postalCode 
 * @param {*} cityZipData - array of {city, zip} objects
 */
export function validateCityZip(city, postalCode, cityZipData) {
    if (!city || !postalCode || !cityZipData) return { valid: false, message: 'Hiányzó adatok' };
    
    const normalizedCity = removeAccents(city);
    const zipNumber = parseInt(postalCode, 10);
    
    if (isNaN(zipNumber)) {
        return { valid: false, message: 'Érvénytelen irányítószám formátum' };
    }
    
    // Find matching entries in city2zip data
    const matchingEntries = cityZipData.filter(entry => 
        removeAccents(entry.city) === normalizedCity && entry.zip === zipNumber
    );
    
    if (matchingEntries.length > 0) {
        return { valid: true, message: 'OK' };
    }
    
    // Check if city exists with different zip
    const cityExists = cityZipData.some(entry => removeAccents(entry.city) === normalizedCity);
    const zipExists = cityZipData.some(entry => entry.zip === zipNumber);
    
    if (cityExists && !zipExists) {
        const correctZips = cityZipData
            .filter(entry => removeAccents(entry.city) === normalizedCity)
            .map(entry => entry.zip);
        
        const uniqueZips = [...new Set(correctZips)].sort((a, b) => a - b);
        const displayZips = uniqueZips.slice(0, 5);
        const zipList = displayZips.join(', ') + (uniqueZips.length > 5 ? ', ...' : '');
        
        return { 
            valid: false, 
            message: `A(z) "${city}" település helyes irányítószáma: ${zipList}` 
        };
    }
    
    if (zipExists && !cityExists) {
        const correctCities = cityZipData
            .filter(entry => entry.zip === zipNumber)
            .map(entry => entry.city);
        
        const uniqueCities = [...new Set(correctCities)];
        const displayCities = uniqueCities.slice(0, 5);
        const cityList = displayCities.join(', ') + (uniqueCities.length > 5 ? ', ...' : '');
        
        return { 
            valid: false, 
            message: `A(z) ${postalCode} irányítószám helyes települése: ${cityList}` 
        };
    }
    
    return { 
        valid: false, 
        message: 'A megadott település és irányítószám kombináció nem található az adatbázisban' 
    };
}